module.exports = {"experienceCloud":"Experience Cloud","touDialogCancelLabel":"重新整理內容","touDialogConfirmLabel":"登入並接受條款","touDialogTitle":"Adobe Experience Cloud 使用條款","touTextLine1":"Adobe Experience Cloud 的使用條款已完成更新。","touTextLine2a":"請登入","touTextLine2b":"並接受更新版條款，以繼續操作。","touTextLine3":"接受條款後，請按一下「重新整理內容」。"}


//////////////////
// WEBPACK FOOTER
// ./src/components/TermsOfUseDialog/__localization__/TermsOfUseDialog/zh_tw.json
// module id = 922
// module chunks = 0